import { ECHARTS_DARK_THEME, ECHARTS_LIGHT_THEME } from '../../content/themes';
import { registerTheme } from 'echarts';

export function registerEchartsThemes() {
  registerTheme('light', ECHARTS_LIGHT_THEME);
  registerTheme('dark', ECHARTS_DARK_THEME);
}
